import { actionCreatorFactory } from 'typescript-fsa';

const actionCreator = actionCreatorFactory('help');

/**
 * ヘルプ関連アクション
 */
export const actions = {
	/**
	 * 初期化
	 */
	INITIALIZE: 'INITIALIZE',
	/**
	 * Storeに設定
	 */
	SET_HELPS: 'SET_HELPS',
} as const;

/**
 * ヘルプ1件分の定義
 */
export interface IGuide {
	/**
	 * 説明文
	 */
	description: string;
	/**
	 * タイトル
	 */
	title: string;
	/**
	 * ファイル配置パス
	 */
	path: string;
	/**
	 * ダウンロード名
	 */
	name: string;
}

/**
 * ヘルプデータ初期化
 */
export const initialize = actionCreator<void>(actions.INITIALIZE);

export type IHelps = Readonly<{
	/**
	 * 受講者画面用ヘルプ一覧
	 */
	participant: IGuide[];
	/**
	 * 受講者画面（ＣＭ）用ヘルプ一覧
	 */
	participantCM: IGuide[];
}>;

/**
 * ヘルプ定義をStoreに設定する
 */
export const setHelps = actionCreator<IHelps>(actions.SET_HELPS);



// WEBPACK FOOTER //
// ./src/actions/help.ts